var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.$isMobile)?_c('pc-navigation-bar'):_c('m-navigation-bar'),(!_vm.$isMobile)?_c('p-market'):_c('m-market'),(!_vm.$isMobile)?_c('pc-footer'):_c('m-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }